import React from 'react';
import PropTypes from 'prop-types';

const Profile = ({ activeUsername }) => {
    return (
        <div>
            <h1>User Profile</h1>
            <p>Email Address: {activeUsername}</p>
        </div>
    );
};

Profile.propTypes = {
    activeUsername: PropTypes.string,
};

export default Profile;
